"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var isDevelopment = process.env.NODE_ENV !== 'production';
var cache = {};
var wrapCache = {};
var addToCache = function (key) {
    cache[key] = true;
};
exports.wrap = function (key) {
    var keyValue = wrapCache[key];
    wrapCache[key] = wrapCache[key] ? keyValue + 1 : 1;
};
exports.unwrap = function (key) {
    if (wrapCache[key]) {
        wrapCache[key]--;
    }
};
function deprecationLog(componentName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isDevelopment && !(cache[componentName] || wrapCache[componentName])) {
        console.warn.apply(console, __spreadArrays(['wix-ui-tpa: [WARNING]'], args));
        addToCache(componentName);
    }
}
exports.deprecationLog = deprecationLog;
//# sourceMappingURL=deprecationLog.js.map